<template>
  <div id="app" :class="{ 'is-mobile': isPhone }">
    <Header />
    <!-- < img src="./assets/logo.png" /> -->
      <router-view/>
    <div class="fixedbutton">
      <!-- <el-popover placement="right" width="400" trigger="click">
        <el-card class="box-card">
          <div class="logo-img">
            <span class="spantitle">联系人：</span><span>周女士</span>
          </div>
          <div class="logo-img">
            <span class="spantitle">手机号码：</span><span>13681028069</span>
          </div>
          <div class="logo-img">
            <span class="spantitle">QQ：</span><span>1763707622</span>
          </div>
        </el-card>

      </el-popover> -->
      <!--      <el-dialog :visible.sync="dialogVisible" :show-close=false width="0%" height="0%">
        <iframe src="https://jq.qq.com/?_wv=1027&k=lh5IB0jC" style="display:none"></iframe>
      </el-dialog>

      <el-button @click="test" type="primary" icon="el-icon-user-solid">在线客服</el-button> -->
      <!--      < img class="jiantou" src="@/assets/image/dianhua.png" /><br/>
      < img class="jiantou" src="@/assets/image/jiantou.png" /> -->

      <div class="img-container2">
        <img src="@/assets/image/dianhua.png" class="default-img2">
        <img src="@/assets/image/faguangdianhua.png" class="hover-img2">
      </div>
      <br />
      <br />
      <br />
      <div class="img-container" :class="{ 'show': showBackToTop }" @click="backToTop">
        <img src="@/assets/image/jiantou.png" class="default-img /">
        <img src="@/assets/image/faguangjiantou.png" class="hover-img /">
      </div>
      <!-- <iframe src="https://jq.qq.com/?_wv=1027&k=lh5IB0jC" style= "display:none">在线客服</iframe> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
        isPhone: window.isPhone,
        drawer: false,
        dialogVisible: false, //弹出框
        // 新增返回顶部按钮的显示状态
        showBackToTop: false
      };
    },
    methods: {
      test() {
        if (this.dialogVisible == true) {
          this.dialogVisible = false;
        } else {
          this.dialogVisible = true;
        }
      },
      // 新增返回顶部方法
      backToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
      // 新增滚动监听方法
      handleScroll() {
        this.showBackToTop = window.pageYOffset > 300;
      }
    },
    mounted() {
      // 添加滚动监听
      window.addEventListener('scroll', this.handleScroll);
      // 初始化检查
      this.handleScroll();
    },
    beforeDestroy() {
      // 移除监听（避免内存泄漏）
      window.removeEventListener('scroll', this.handleScroll);
    }
  };
</script>


<style>
  .img-container {
    position: relative;
    /* 关键：让子图片绝对定位 */
    display: inline-block;
    /* 根据布局调整 */
    width: 80px;
    height: 80px;
    right: 20%;
    object-fit: contain;
    cursor: pointer;
    /* 鼠标悬停时显示手型 */
  }

  /* 图片通用样式 */
  .img-container img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.8s ease;
    /* 过渡动画 */
  }

  /* 默认显示普通箭头，隐藏发光箭头 */
  .default-img {
    opacity: 1;
  }

  .hover-img {
    opacity: 0;
  }


  /* 悬停时切换：隐藏普通箭头，显示发光箭头 */
  .img-container:hover .default-img {
    opacity: 0;
  }

  .img-container:hover .hover-img {
    opacity: 1;
  }

  /* img2 */
  /* 容器优化版（保持右侧固定） */
  .img-container2 {
    position: fixed;
    right: 17px;
    transform: translateY(-50%);
    z-index: 1000;
    width: 80px;
    /* 匹配默认图标宽度 */
    height: 80px;
    overflow: visible;
    /* 允许超出发光图标显示 */
  }

  /* 默认图标（精准控制） */
  .default-img2 {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    position: relative;
    /* 改为相对定位 */
    transition: all 0.3s ease;
    z-index: 1;
  }

  /* 发光图标（精确弹出控制） */
  .hover-img2 {
    width: 340.9px;
    height: 80px;
    object-fit: contain;
    position: absolute;
    top: 50%;
    left: 100%;
    /* 从容器右侧起始 */
    transform: translateY(-50%);
    opacity: 0;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
    z-index: 2;
    pointer-events: none;
    /* 避免悬停区域冲突 */
  }

  /* 悬停状态优化 */
  .img-container2:hover .hover-img2 {
    left: calc(100% - 341px);
    /* 精确控制弹出距离 */
    opacity: 1;
  }

  .img-container2:hover .default-img2 {
    opacity: 0;
    /* 可选：默认图标半透明 */
  }

  /*  */



  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* margin-top: 60px; */
    min-width: 1200px;
  }

  .pagew {
    width: 1200px;
    margin: auto;
    position: relative;
  }

  .banner-text-box {
    text-align: left;
    background: url("./assets/image/text-box.png") no-repeat;
    width: 778px;
    height: 230px;
    top: 230px;
    padding: 80px 50px 80px 30px;
    box-sizing: border-box;
    color: #fff;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transform-origin: center center;
  }

  .banner-text-box p {
    text-indent: 25px;
    line-height: 22px;
    margin-bottom: 20px;
    padding-right: 230px;
  }

  .fixedbutton {
    position: fixed;
    bottom: 100px;
    right: 0;
  }



/* 确保路由视图容器正确 */
router-view {
  position: relative;
  display: block;
}

  /* @media screen and (max-width: 1580px) {
  .banner-text-box {
    transform: translateX(-50%) scale(.8);
    top: 180px;
  }
}
@media screen and (max-width: 1280px) {
  .banner-text-box {
    transform: translateX(-50%) scale(.65);
    top: 220px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/App.vue